import { Breakpoints } from 'JBSrc/constants';

jQuery($ => {
	//calculate spacing for header filters
	const headerFilter = $('.js-header-filter');
	const mainContainer = $('.maincontent');

	if (!headerFilter.length) {
		return;
	}

	function setStyles() {
		const headerFilterHeight = headerFilter.outerHeight();
		const header = mainContainer.find('.page-header');
		let margin = headerFilterHeight / 2;

		//for support page header - need more space for buttons.
		if ($('.support-header__buttons').length) {
			const buttonsHeight = $('.support-header__buttons').outerHeight();
			margin = margin + buttonsHeight;
		}

		//shitty code for now - FIX repetition.
		if ($('.search-header__buttons').length && $(window).width() >= Breakpoints.md) {
			const buttonsHeight = $('.search-header__buttons').outerHeight();
			headerFilter.css({ transform: `translateY(calc(-50% - ${buttonsHeight / 2}px))` });
			// margin = margin + buttonsHeight;
		}

		// mainContainer.css({ 'padding-top': `${margin}px` });
		header.css({ 'padding-bottom': `${margin}px` });
	}

	setStyles();
	window.addEventListener('resize', setStyles);

	headerFilter.addClass('show');
});
